/**
 * Registers /sw.js in production builds (no SW during `craco start` to avoid
 * caching the hot-reload bundle).
 */
export function registerServiceWorker() {
  if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/sw.js")
        .catch(() => { /* ignore registration errors */ });
    });
  }
}
